import { cssUtil } from "../../utils/cssUtil";
import { getBaseStyles } from "../commonStyles";

export async function renderFormStepWidget(context, widget, parent, override = null) {

    // <form class="widget form_step_widget">
    const form = context.document.createElement("form");
    form.classList.add("widget", "form_step_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    form.setAttribute("style", cssUtil.toStyleString(styles));
    form.setAttribute("data-widgetId", widget.uid);
    form.setAttribute("data-widgetType", widget.type);
    form.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(form);

    // Render children
    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || !children.length) return form;

    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;

        const renderer = context.renderers[child.type];
        if (!renderer) continue;

        await renderer(context, child, form);
    }

    return form;
}